import { Eyebrow, Grid, Stack, Text } from "@generalapplications/ui";

import { NumberedList } from "./NumberedList";
import { SectionHeader } from "@/app/common/components/composite/layout/SectionHeader";
import { Reveal } from "@/app/common/components/composite/motion/Reveal";
import { homePage } from "@/content/home";
import { formatText } from "@/app/common/functions/format/formatText";

/** Where systems fail, beside the numbered principles that keep them from it. */
export function Philosophy() {
  return (
    <Grid as="section" columns={{ base: 1, lg: 2 }} gap="xxl" align="start">
      <Reveal>
        <Stack gap="lg">
          <SectionHeader title={homePage.philosophy.headline} />
          {homePage.philosophy.copy.map((paragraph) => (
            <Text key={paragraph} variant="prose">
              {formatText(paragraph)}
            </Text>
          ))}
        </Stack>
      </Reveal>
      <Stack gap="md">
        <Eyebrow tone="muted">Principles</Eyebrow>
        <NumberedList
          items={homePage.philosophy.principles}
          ariaLabel="Engineering principles"
        />
      </Stack>
    </Grid>
  );
}
